
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_dm8gx_1gibp_3",
  "has-items": "awsui_has-items_dm8gx_1gibp_12",
  "token": "awsui_token_dm8gx_1gibp_16",
  "dismiss-button": "awsui_dismiss-button_dm8gx_1gibp_28",
  "token-disabled": "awsui_token-disabled_dm8gx_1gibp_62",
  "toggle": "awsui_toggle_dm8gx_1gibp_76",
  "description": "awsui_description_dm8gx_1gibp_107"
};
  